// extracted by mini-css-extract-plugin
export default {"card-list":"A8CExI","container":"hvwcsJ","main":"K0KpOf","icon":"tprXES","title":"GvQXIj"};